import {apiInstance} from '../api_Instance';
import {queryOptions} from '@tanstack/react-query';

export const faqApi = {
  getFaqList: (questionsType) => {
    return queryOptions({
      queryKey: ['faq', 'list', questionsType],
      queryFn: () => apiInstance.get(`/faq/?category__code=${questionsType}`),
    });
  },
};
